<div class="vertical-filters" [ngClass]="{ collapsed: !isFiltersMenuOpen }">
  <div class="vertical-filters-header">
    <div class="header__left-side">
      <img src="assets/images/common/filter.svg" (click)="onToggleClick()" alt="filter" />
      <div>Filters</div>
    </div>
    <img
      src="assets/images/arrows/chevron.svg"
      class="vertical-filters-header-img"
      (click)="onToggleClick()"
      alt="toggle"
    />
  </div>
  <div class="vertical-filters-options">
    <div class="vertical-filters-options-container">
      @if (optionsInsideCategories$ | async; as optionGroups) {
        @for (optionGroup of optionGroups; track optionGroup.displayName) {
          <app-accordion
            [inMultiSelect]="true"
            [expanded]="expandedCategories[optionGroup.displayName!]"
            [accordionTitle]="optionGroup.displayName!"
            (accordionExpansionEvent)="expandClicked(optionGroup.displayName!, $event)"
          >
            @for (option of optionGroup.options; track option.id) {
              <div
                class="vertical-filters-option"
                [ngClass]="{
                  'vertical-filters-option-selected': selectedIds.has(option.id) && !option.disabled,
                  'vertical-filters-option-disabled': option.disabled,
                }"
                (click)="onSelect(option.id)"
              >
                <mat-checkbox
                  color="primary"
                  [checked]="selectedIds.has(option.id)"
                  (click)="$event.stopPropagation()"
                  (change)="onSelect(option.id)"
                >
                </mat-checkbox>
                <div class="vertical-filters-option-text" appLongTextTooltip>
                  {{ option.displayName }}
                </div>
              </div>
            }
          </app-accordion>
        }
      }

      <app-accordion [inMultiSelect]="true" [expanded]="false" [accordionTitle]="'Object Identifier'">
        <div>
          <input
            type="text"
            class="object-identifier-input"
            [formControl]="objectIdentifierCtrl"
            (keydown.enter)="onObjectIdentifierEnter()"
            placeholder="Enter object ID"
          />
        </div>
      </app-accordion>
    </div>
  </div>
</div>
<div [ngClass]="{ collapsed: isFiltersMenuOpen }">
  <img
    src="assets/images/arrows/filters-menu-closed.svg"
    (click)="onToggleClick()"
    class="collapsed-img"
    alt="collapse"
  />
</div>
